import type * as React from "react";

import { markShape, type SwipeTone, toneWash } from "./Swipe";
import { cn } from "../lib/cn";

export interface BandProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone: SwipeTone;
  icon?: React.ReactNode;
  /** A string because it truncates and rides the root's `title`. */
  children: string;
  ref?: React.Ref<HTMLSpanElement>;
}

/** A full-width Swipe heading a sheet: the state the whole paper wears. */
export function Band({ tone, icon, children, className, ...rest }: BandProps) {
  return (
    <span
      className={cn(
        toneWash[tone],
        "blend-marker rounded-t-paper text-ink",
        "flex w-full min-w-0 items-center gap-1 px-2 py-1",
        className,
      )}
      {...rest}
      title={children}
    >
      {icon != null && (
        <span aria-hidden="true" className={markShape.icon}>
          {icon}
        </span>
      )}
      <span className="min-w-0 flex-1 truncate">{children}</span>
    </span>
  );
}
